/* REDTEC v29 · Favoritos do Clube REDTEC via app Wishlist Hero.
   Visitante: o coração abre o convite REDTEC (Cadastro e Login Clube REDTEC) no lugar do popup do app.
   Cliente logado: o app salva na conta; o coração do cabeçalho abre a lista e mostra a contagem. */
(function () {
  var C = window.rtLikeCfg || {};
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.7s-7.6-4.6-9.4-9.3C1.3 8 3.3 4.6 6.8 4.3c2-.2 3.9.8 5.2 2.5 1.3-1.7 3.2-2.7 5.2-2.5 3.5.3 5.5 3.7 4.2 7.1-1.8 4.7-9.4 9.3-9.4 9.3z"/></svg>';
  function launcher() { return document.querySelector('#wishlisthero-floating-launcher-container a, #wishlisthero-floating-launcher-container [role="button"]'); }
  function count() {
    var b = document.querySelector('#wishlisthero-floating-launcher-container .MuiBadge-badge');
    var n = b ? parseInt(b.textContent, 10) || 0 : 0;
    document.querySelectorAll('[data-rt-likes-count]').forEach(function (e) { e.textContent = n; e.hidden = !n; });
  }
  function dialog(html) {
    var d = document.getElementById('rt-lk-dialog');
    if (!d) {
      d = document.createElement('dialog'); d.id = 'rt-lk-dialog'; d.className = 'rt-lk rt-lk--login'; document.body.appendChild(d);
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-rt-lk-close]')) d.close(); });
    }
    d.innerHTML = '<button type="button" class="rt-lk__x" data-rt-lk-close aria-label="Fechar">×</button><div class="rt-lk__in">' + html + '</div>';
    if (!d.open) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); }
  }
  function convite(doCabecalho) {
    dialog(
      '<div class="rt-lk__ic">' + HEART + '</div>' +
      '<p class="rt-lk__eyebrow">Clube REDTEC</p>' +
      '<h2 class="rt-lk__t">' + (doCabecalho ? 'Seus favoritos ficam no Clube' : 'Entre para salvar este favorito') + '</h2>' +
      '<p class="rt-lk__p">Faça o cadastro ou o login no Clube REDTEC para guardar as malas que você curtiu e voltar a elas quando quiser, em qualquer aparelho.</p>' +
      '<a class="rt-lk__btn" href="' + (C.login || '/account') + '">Cadastro e Login Clube REDTEC</a>' +
      '<a class="rt-lk__link" href="/pages/termos-de-uso#clube-redtec">Conheça as regras do Clube</a>'
    );
  }
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('.wishlist-hero-custom-button, #wishlisthero-product-page-button-container');
    var open = e.target.closest('[data-rt-likes-open]');
    if (!heart && !open) return;
    if (!C.customer) { e.preventDefault(); e.stopPropagation(); convite(!!open); return; }
    if (open) { e.preventDefault(); var l = launcher(); if (l) l.click(); }
  }, true);
  var t;
  function start() {
    count();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(count, 150); }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
